/**
 * メタフィールドデータローダー
 * Liquidから渡されたメタフィールドデータを安全に変換・処理する
 */

/**
 * 安全なJSON変換関数
 * @param {*} data - 変換対象のデータ
 * @param {*} fallback - 失敗時のフォールバック値
 * @returns {*} 変換後のデータ
 */
window.safeParseJSON = function(data, fallback = {}) {
  try {
    // 既にオブジェクトの場合はそのまま返す
    if (typeof data === 'object' && data !== null) {
      return data;
    }
    // 文字列の場合はパース
    if (typeof data === 'string' && data) {
      return JSON.parse(data);
    }
    // それ以外はフォールバック
    return fallback;
  } catch (e) {
    console.warn('[MetafieldLoader] JSON parse error:', e, 'Data:', data);
    return fallback;
  }
};

/**
 * 価格マトリックスデータを統一形式に変換
 * @param {Object} rawPriceMatrix - 生の価格マトリックスデータ
 * @returns {Object} 統一形式の価格データ
 */
window.normalizePriceMatrix = function(rawPriceMatrix) {
  const allPriceData = [];
  const variationsData = {};
  
  // データ構造を判定して変換
  if (rawPriceMatrix.matrix && rawPriceMatrix.matrix.quantity_delivery_combinations) {
    // 旧形式: matrix.quantity_delivery_combinations
    return {
      price_data: rawPriceMatrix.matrix.quantity_delivery_combinations,
      variations: {}
    };
  }
  
  if (rawPriceMatrix.variations && typeof rawPriceMatrix.variations === 'object') {
    // バッチインポート形式
    
    for (const [varCode, pricesData] of Object.entries(rawPriceMatrix.variations)) {
      // 配列形式の場合
      if (Array.isArray(pricesData)) {
        pricesData.forEach(priceEntry => {
          allPriceData.push(priceEntry);
        });
      }
      // ネスト形式の場合
      else if (typeof pricesData === 'object' && pricesData !== null) {
        const quantities = Object.keys(pricesData).map(Number).sort((a, b) => a - b);
        
        variationsData[varCode] = { quantities };
        
        for (const [quantityStr, deliveryPrices] of Object.entries(pricesData)) {
          const quantity = parseInt(quantityStr);
          
          if (typeof deliveryPrices === 'object' && deliveryPrices !== null) {
            for (const [deliveryKey, price] of Object.entries(deliveryPrices)) {
              // 共通関数で納期キーを変換
              const deliveryTime = window.convertDeliveryKey ? window.convertDeliveryKey(deliveryKey) : `${deliveryKey}営業日`;
              
              if (price && price > 0) {
                allPriceData.push({
                  variation_code: varCode,
                  quantity,
                  delivery_time: deliveryTime,
                  base_price: price
                });
              }
            }
          }
        }
      }
    }
    
    return {
      price_data: allPriceData,
      variations: Object.keys(variationsData).length > 0 ? variationsData : rawPriceMatrix.variations
    };
  }
  
  // 統合形式: { バリエーションコード: [価格配列] }
  if (Object.keys(rawPriceMatrix).length > 0 && Array.isArray(rawPriceMatrix[Object.keys(rawPriceMatrix)[0]])) {
    
    for (const [varCode, pricesArray] of Object.entries(rawPriceMatrix)) {
      pricesArray.forEach(priceEntry => {
        const quantity = parseInt(priceEntry.quantity || priceEntry.部数);
        const excludeKeys = ['quantity', '部数', 'delivery_days', 'バリエーションコード', '商品コード', 'バリエーション詳細'];
        const deliveryKeys = Object.keys(priceEntry).filter(k => !excludeKeys.includes(k));
        
        deliveryKeys.forEach(deliveryKey => {
          // 共通関数で納期キーを変換
          const deliveryTime = window.convertDeliveryKey ? window.convertDeliveryKey(deliveryKey) : `${deliveryKey}営業日`;
          const price = priceEntry[deliveryKey];
          
          if (price && price > 0) {
            allPriceData.push({
              variation_code: varCode,
              quantity,
              delivery_time: deliveryTime,
              base_price: price
            });
          }
        });
      });
    }
    
    return {
      price_data: allPriceData,
      variations: rawPriceMatrix
    };
  }
  
  console.warn('[MetafieldLoader] Unknown format');
  return { price_data: [], variations: {} };
};

/**
 * バリエーションメタフィールドから価格データを生成
 * @param {Array} variantMetafields - バリエーションメタフィールド配列
 * @returns {Object} 価格データ
 */
window.processVariantMetafields = function(variantMetafields) {
  const variantPriceData = [];
  const variationsData = {};
  let hasData = false;
  
  variantMetafields.forEach((variantMeta, index) => {
    if (!variantMeta.matrix) return;
    
    const paper = variantMeta.option1;
    const printColor = variantMeta.option2;
    const variationCode = `${paper}_${printColor}`;
    const matrixData = variantMeta.matrix;
    
    if (matrixData && Object.keys(matrixData).length > 0) {
      hasData = true;
      
      if (index === 0) {
      }
      
      const quantities = Object.keys(matrixData).map(Number).sort((a, b) => a - b);
      
      variationsData[variationCode] = {
        paper,
        printColor,
        quantities
      };
      
      quantities.forEach(qty => {
        const deliveryPrices = matrixData[qty];
        if (!deliveryPrices || typeof deliveryPrices !== 'object') {
          console.warn(`[MetafieldLoader] No delivery prices for quantity ${qty} in ${variationCode}`);
          return;
        }
        
        Object.keys(deliveryPrices).forEach(deliveryTime => {
          const price = deliveryPrices[deliveryTime];
          if (price && price > 0) {
            variantPriceData.push({
              variation_code: variationCode,
              quantity: qty,
              delivery_time: deliveryTime,
              base_price: price
            });
          }
        });
      });
    }
  });
  
  if (hasData) {
    
    return {
      variations: variationsData,
      price_data: variantPriceData
    };
  }
  
  return null;
};


